var Queue = /** @class */ (function () {
    function Queue() {
        this._storage = {};
        this._length = 0;
        this._head = 0;
        this._tail = 0;
    }
    Queue.prototype.enqueue = function (value) {
        this._storage[this._tail++] = value;
        this._length++;
    };
    Queue.prototype.dequeue = function () {
        var removedElement = this._storage[this._head];
        delete this._storage[this._head];
        if (this._head < this._tail)
            this._head++;
        this._length--;
        return removedElement;
    };
    Object.defineProperty(Queue.prototype, "length", {
        get: function () {
            return this._length;
        },
        enumerable: false,
        configurable: true
    });
    Queue.prototype.peek = function () {
        return this._storage[this._head];
    };
    return Queue;
}());
export default Queue;
//# sourceMappingURL=Queue.js.map